<template>
  <div class="scrm-select row flex-center" v-if="!hideleftTitle">
    <div class="font-666 bg-white left-label">{{ leftTitle }}</div>
    <el-select
      ref="currentSelect"
      class="fw100"
      :clearable="clearable"
      :filterable="filterable"
      :placeholder="placeholder"
      v-model="self[modelval]"
      v-bind="$attrs"
      @clear="resizeOptions"
      @visible-change="resizeOptions"
      @focus="handleSelectFocus"
      :filter-method="PinyinMatchFuncomplaint"
      :loading="loading"
    >
      <slot name="firstOption"></slot>
      <el-option
        v-for="item in selfoption"
        :key="item[value]"
        :label="item[label]"
        :value="item[value]"
      >
      </el-option>
    </el-select>
  </div>
  <div v-else>
    <!--不要左边title的组件，只有下拉框-->
    <el-select
      ref="currentSelect"
      class="fw100"
      :clearable="clearable"
      :filterable="filterable"
      :placeholder="placeholder"
      v-model="self[modelval]"
      v-bind="$attrs"
      @clear="resizeOptions"
      @visible-change="resizeOptions"
      @focus="handleSelectFocus"
      :filter-method="PinyinMatchFuncomplaint"
      :loading="loading"
    >
      <slot name="firstOption"></slot>
      <el-option
        v-for="item in selfoption"
        :key="item[value]"
        :label="item[label]"
        :value="item[value]"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import func from "@/util/func.js";
import PinyinMatch from "pinyin-match";

export default {
  name: "scrm-select",
  inheritAttrs: false,
  props: {
    self: {
      type: Object,
      required: true,
    },
    modelval: {
      //默认值
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      default: "label",
    },
    value: {
      type: String,
      default: "value",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    filterable: {
      //自定义筛选
      type: Boolean,
      default: true,
    },
    placeholder: {
      //自定义筛选
      type: String,
      default: "请选择",
    },
    leftTitle: {
      //左边的标题
      type: String,
      default: "",
    },
    hideleftTitle:{
      type: Boolean,
      default: false,
    }
  },
  components: {},
  data: function () {
    return {
      selfoption: [],
      selfoptionback: [],
      isFirstLoad: true,
      loading: true,
    };
  },
  mounted: function () {
    this.$nextTick(() => {
      if (func.notEmpty(this.self[this.modelval])) {
        this.getOption();
      }
      if (this.options.length > 0) {
        this.selfoption = func.copyArr(this.options);
        this.selfoptionback = func.copyArr(this.options);
        this.loading = false;
        this.isFirstLoad = false;
      }
    });
  },
  watch: {
    options(val) {
      this.selfoption = func.copyArr(val);
      this.selfoptionback = func.copyArr(val);
      this.loading = false;
      this.isFirstLoad = false;
    },
  },
  methods: {
    valChange(e) {
      let that = this;
      // that.$emit("change", { value: e });
    },
    PinyinMatchFuncomplaint(val) {
      if (val) {
        let result = [];
        console.log(this.selfoptionback);
        this.selfoptionback.forEach((i) => {
          let m = PinyinMatch.match(i[this.label], val);
          if (m) {
            result.push(i);
          }
        });
        // 将过滤后的数组重新赋给下拉列表数据
        // result = this.removeRepet(result, "value");
        this.selfoption = func.copyArr(result);
      } else {
        // 如果输入框为空, 则将下拉列表数据还原
        this.selfoption = this.selfoptionback;
      }
    },
    resizeOptions() {
      //重置option
      this.selfoption = func.copyArr(this.selfoptionback);
    },
    // removeRepet(list, key) {
    //   //根据数组的某个值去重
    //   let map = new Map();
    //   list.forEach((item) => {
    //     if (!map.has(item[key])) map.set(item[key], item);
    //   });
    //   return [...map.values()];
    // },
    valblur() {
      this.$emit("valblur");
    },
    selectblur() {
      let that = this;
      that.$refs.currentSelect.blur();
    },
    handleSelectFocus() {
      //第一次点击加载列表
      if (this.isFirstLoad) {
        const { options } = this;
        if (options.length === 0) {
          this.getOption();
        }
      }
    },
    getOption() {
      this.$emit("getOption");
    },
    clear() {
      this.selfoption = [];
      this.selfoptionback = [];
      this.isFirstLoad = true;
      this.loading = true;
    },
  },
};
</script>

<style scoped lang="scss">
.scrm-select {
  :deep(.el-select__wrapper) {
    box-shadow: none !important;
    border: 1px solid #e6e6e6;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    box-sizing: border-box;
    height: 34px;
    &.is-focused {
      box-shadow: none !important;
      .el-select__input-wrapper {
        box-shadow: none !important;
      }
    }
  }

  :deep(.el-select__tags) {
    flex-wrap: nowrap !important;
  }

  :deep(.el-select__tags-text) {
    max-width: 100px !important;
  }

  .left-label {
    font-size: 14px;
    height: 34px;
    line-height: 32px;
    border: 1px solid #e6e6e6;
    border-right: 0;
    box-sizing: border-box;
    padding: 0 10px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    white-space: nowrap;
    color: #666;
  }
}
</style>
